import React, { useEffect, useState, useRef } from 'react'
import './Home.css';
import ProfileSide from '../../components/ProfileSide/ProfileSide';
import Main from '../../components/Main/Main';
import Header from '../../components/Header/Header';
import { useDispatch, useSelector } from 'react-redux';
import { useDisclosure } from '@mantine/hooks';
import { Modal, useMantineTheme } from '@mantine/core';
import usePageTracking from '../../hooks/usePageTracking';
import { fetch_theme } from '../../api/ItemManipulation';
import { setTheme } from '../../actions/ThemeAction';
import BackToTopButton from '../../components/Main/Button/BackToTopButton';

const Home = () => {
    usePageTracking('ns_home');
    const [opened, { open, close }] = useDisclosure(false);
    const theme = useMantineTheme();

    const dispatch = useDispatch();
    const { modalData, rModalOpened, loading } = useSelector((state) => state.modalReducer);
    const { user } = useSelector((state) => state.authReducer.authData);

    // Resend cooldown state
    const [cooldown, setCooldown] = useState(0);
    const cooldownRef = useRef(null);

    const handleResend = async () => {
        if (cooldown > 0) return;

        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/resend-verification/${user._id}`, {
                method: 'POST',
                credentials: 'include'
            });

            // Start 60 second countdown
            setCooldown(60);
            cooldownRef.current = setInterval(() => {
                setCooldown(prev => {
                    if (prev <= 1) {
                        clearInterval(cooldownRef.current);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            console.error('Resend failed:', error);
        }
    };

    useEffect(() => {
        return () => {
            if (cooldownRef.current) clearInterval(cooldownRef.current);
        };
    }, []);

    useEffect(() => {
        open();
    }, [loading]);

    const init = async () => {
        const res = await fetch_theme();
        dispatch(setTheme(res.data));
    };

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        if (rModalOpened === true) {
            open();
        } else {
            close();
        }
    }, [rModalOpened]);

    return (
        <div className="Home HeaderGrid">
            <a href="#top" id="top"></a>
            <div className='home-header-container'>
                <Header location="home" />
            </div>
            {!user.emailVerified && (
                <div style={{
                    background: '#fffbeb',
                    border: '1px solid #f59e0b',
                    borderRadius: 4,
                    padding: '6px 12px',
                    fontSize: 12,
                    color: '#92400e',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8
                }}>
                    <span>📧 Please verify your email address to secure your account.</span>
                    <button
                        style={{
                            fontSize: 11,
                            padding: '2px 8px',
                            cursor: cooldown > 0 ? 'not-allowed' : 'pointer',
                            opacity: cooldown > 0 ? 0.6 : 1,
                            minWidth: 90,
                            transition: 'opacity 0.2s'
                        }}
                        onClick={handleResend}
                        disabled={cooldown > 0}
                    >
                        {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend Email'}
                    </button>
                </div>
            )}
            <div className='BodyGrid'>
                <ProfileSide />
                <Main />
            </div>
            <BackToTopButton />
        </div>
    );
};

export default Home;